import { render, staticRenderFns } from "./ImagePoliciesInfo.vue?vue&type=template&id=34b73f1e&"
import script from "./ImagePoliciesInfo.vue?vue&type=script&lang=js&"
export * from "./ImagePoliciesInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports